import './HomeBackground.css';

const HomeBackground = () => (
    <div className="home-header bgimg">
    </div>
);

export default HomeBackground;
